import type { CSSProperties } from 'react';

import { isString } from 'lodash';
import type { Element } from 'slate';

import { isUrlValid } from '@flow/libs/forms/validators/url';

import { VALID_PROTOCOLS } from './constants';

export const getStyle = (element: Element): CSSProperties => {
  const style = {
    ...element.style,
  };

  if (element.backgroundColor) style.backgroundColor = element.backgroundColor;
  if (element.color) style.color = element.color;
  if (element.fontSize) style.fontSize = element.fontSize;
  if (element.marginLeft) style.marginLeft = element.marginLeft;
  if (element.textAlign) style.textAlign = element.textAlign;

  return style;
};

export const getHref = ({ url }: Element) => {
  if (!url || !isString(url) || (!url.startsWith('mailto:') && !isUrlValid(url, VALID_PROTOCOLS))) {
    return '';
  }

  return url;
};

export const getTarget = ({ url }: Element) => {
  if (url && url.startsWith('mailto:')) return undefined;

  return '_blank';
};
